import React, {useContext, useState} from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItem from '@material-ui/core/ListItem';
import Hidden from '@material-ui/core/Hidden';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import {Language} from '@material-ui/icons';

import _firebaseContext from '../../../contexts/firebaseContext';
import _appContext from '../../../contexts/appContext';

const SaveLanguageModal = ({modalVisibilityHandler, visibility, updateLanguagesList}) => {
    const firebaseContext = useContext(_firebaseContext);
    const appContext = useContext(_appContext);
    const [languageId, setLanguageId] = useState('');
    const [languageRepresentation, setLanguageRepresentation] = useState('');

    const languageIdHandler = event => {
        setLanguageId(event.target.value);
    }

    const languageRepresentationHandler = event => {
        setLanguageRepresentation(event.target.value);
    }

    const clearData = () => {
        setLanguageId('');
        setLanguageRepresentation('');
    }

    const closeModal = () => {
        clearData();
        modalVisibilityHandler();
    }

    const submitHandler = async () => {
        const trimmedLanguageId = languageId.trim();
        const trimmedLanguageRepresentation = languageRepresentation.trim();

        if (trimmedLanguageId && trimmedLanguageRepresentation) {
            try {
                const language = {
                    languageId: trimmedLanguageId.toLowerCase(),
                    represent: trimmedLanguageRepresentation.toLowerCase()
                };
                const isLanguageDataSent = await firebaseContext.saveLanguage(language);

                if (isLanguageDataSent) {
                    const isTipsLanguageCollectionExists = await firebaseContext.checkIfLanguageCollectionExists(`tips_${language.languageId}`);

                    if (isTipsLanguageCollectionExists === undefined) {
                        appContext.snackbar.showSnackbarMsg('Произошла ошибка, не удалось добавить новый язык для подсказок')
                    }
                    if (isTipsLanguageCollectionExists !== undefined && !isTipsLanguageCollectionExists) {
                        const isTipsLanguageDataSent = await firebaseContext.setNewTipsLanguageCollection(`tips_${language.languageId}`);

                        if (!isTipsLanguageDataSent) {
                            appContext.snackbar.showSnackbarMsg('Произошла ошибка, не удалось добавить новый язык для подсказок')
                        }
                    }

                    updateLanguagesList(language);
                }
                if (!isLanguageDataSent) {
                    appContext.snackbar.showSnackbarMsg('Произошла ошибка, не удалось добавить новый язык')
                }

                closeModal();
            } catch (e) {
                appContext.snackbar.showSnackbarMsg('Произошла ошибка, попробуйте повторить запрос позднее')
            }
        }
    }

    return (
        <Dialog
            open={visibility}
            onClose={closeModal}
            maxWidth='sm'
            fullWidth={true}
        >
            <DialogTitle>Добавление нового языка</DialogTitle>
            <DialogContent>
                <List>
                    <ListItem>
                        <Hidden xsDown>
                            <ListItemIcon>
                                <Language/>
                            </ListItemIcon>
                        </Hidden>
                        <TextField
                            autoFocus
                            fullWidth
                            label='Короткий идентификатор языка'
                            type='text'
                            value={languageId}
                            onChange={languageIdHandler}
                            placeholder={'en'}
                            required
                        />
                    </ListItem>
                    <ListItem>
                        <Hidden xsDown>
                            <ListItemIcon>
                                <Language/>
                            </ListItemIcon>
                        </Hidden>
                        <TextField
                            fullWidth
                            label='Название языка'
                            type='text'
                            value={languageRepresentation}
                            onChange={languageRepresentationHandler}
                            placeholder={'english'}
                            required
                        />
                    </ListItem>
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeModal} color='primary'>
                    Отмена
                </Button>
                <Button
                    onClick={submitHandler}
                    color='primary'
                    disabled={!languageId.trim() || !languageRepresentation.trim()}
                >
                    Сохранить
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default SaveLanguageModal;
